<template>
  <div>
    <div class="layout-header" ref="searchBox">
      <div class="infor-layout-header">
        <span class="title">站点同步</span>
      </div>
      <el-form
        :inline="true"
        :model="copy"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="品牌：">
          <el-select v-model="copy.brandId" placeholder="请选择品牌" clearable>
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in brands"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期：">
          <el-date-picker
            v-model="copy.dataRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="check">查询</el-button>
          <el-button type="primary" @click="refresh" style="background-color: #3e7878;border-color: #3e7878">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 10.3125rem"></div>
    <div class="pagination-bg-white layout-header">
      <w-table
        width="100%"
        v-show="checkUserAuth(4, 14)"
        v-loading.body="tableLoading"
        :height="tableViewHeight"
        :data-list="tabledata"
        :columns="columns"
        :pageNo="formData.pageNum"
        :pageSize="formData.pageSize"
        :total="total"
        @pageNoChange="pageNoChange"
        @pageSizeChange="handleSizeChange"
      >
        <template slot-scope="{ text }" slot="cell">
          <span>{{ text }}</span>
        </template>
      </w-table>
      <div v-show="!checkUserAuth(4, 14)">您的账户没有权限查看此内容！</div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
import WTable from '@/components/Table/index.vue'
export default {
  name: 'sitesync',
  components: {
    WTable
  },
  data() {
    return {
      copy: {},
      form: {},
      tableViewHeight: '',
      columns: [
        {
          prop: 'brand_name',
          label: '品牌'
        },
        {
          prop: 'create_time',
          label: '日期'
        }
      ],
      tableLoading: true,
      tabledata: [],
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userLevel', 'brands'])
  },
  created() {
    this.refresh()
  },
  methods: {
    check() {
      this.form = { ...this.copy }
      this.getData()
    },
    refresh() {
      this.form = {
        dataRange: [this.dayjs().startOf('M').format('YYYY-MM-DD HH:mm:ss'),
          this.dayjs().endOf('M').format('YYYY-MM-DD HH:mm:ss')]
      }
      this.copy = { ...this.form }
      this.formData.pageNum = 1
      this.formData.pageSize = 10
      this.getData()
    },
    getData() {
      this.tableLoading = true
      const postdata = {
        selfAreaId: this.selfAreaId,
        currentPage: this.formData.pageNum,
        pageSize: this.formData.pageSize
      }
      if (this.form.brandId) {
        postdata.brandId = this.form.brandId
      }
      if (this.form.dataRange) {
        postdata.startTime = this.form.dataRange[0]
        postdata.endTime = this.form.dataRange[1]
      }
      Api.getSyncSiteLogList(postdata).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tabledata = res.data.lists
          this.total = res.data.total
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.getData()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.getData()
    }
  }
}
</script>

<style lang="less">
.layout-header {
  margin: 16px;
  width: calc(98% - 20px);
}

.demo-form-inline{
  margin-top: 24px;
}
</style>
